import { createVersionCheck, type IVersionCheck, readVersionCheckSettings, versionJsonUrl } from '@srm/core/version';
import { ConfigService } from '@/configuration/services/configService';
import { BASE_PATH } from '@/configuration';
import { APP_VERSION } from '@/configuration/appVersion';
import { versionUpdate } from '@utils/versionUpdate';

let versionCheck: IVersionCheck | null = null;

/** Запустить проверку версии вкладки по настройкам конфига (повторный вызов перезапускает её). */
export const initErrorHandlers = (): void => {
    versionCheck?.stop();
    const { enabled, intervalMs } = readVersionCheckSettings(() => ConfigService.get().application.versionCheck);
    versionCheck = createVersionCheck({
        enabled,
        intervalMs,
        buildVersion: APP_VERSION,
        versionUrl: () => versionJsonUrl(BASE_PATH),
        onNewVersion: versionUpdate.offer,
    });
    versionCheck.start();

    // При уходе со страницы — снять таймер и подписку.
    window.addEventListener('beforeunload', () => {
        destroyErrorHandlers();
    });
};

/** Остановить проверку версии. */
export const destroyErrorHandlers = (): void => {
    versionCheck?.stop();
    versionCheck = null;
};
